import React, {Component} from 'react';
import axios from 'axios';
import Table from '../components/pivottable';

const neo4jUrl = process.env.REACT_APP_NEO4J_API;
const AUTHORIZATION = process.env.REACT_APP_NEO4J_PASSWORD;
const DEFAULT = {
    rows: ['biosample'],
    cols: ['assay'],
    data: []
}
class Neo4jDirect extends Component {
    state = {data: []}

    componentDidMount() {
        axios.post(neo4jUrl, {
            statements: [
                {
                    statement: query
                }
            ]
        }, {
                headers: {
                    Authorization: AUTHORIZATION
                }
            })
            .then(res => this.setState({ data: formatResults(res)}))
            .catch(err => console.log(err))
    }
    render() {
        if (this.state.data.length === 0) {
            return <p>Loading ...</p>
        }
        return (
            <div className="m-8 p-8">
                COMPLETE METADATA - REALTIME
                <Table data={this.state.data} DEFAULT={DEFAULT}/>
            </div>
        );
    }
}

export default Neo4jDirect;

const query = `
    MATCH (f:file)-[s:sequenced]->(a:assay)-[i:assay_input]->(b:biosample)-[fr:derived_from]->(m:mouse)-[:undergoes]->(t:treatment)
    where f.run_type = "paired-end" AND f.pair = "forward" 
    RETURN DISTINCT  t.exposure_specific as treatment, 
    a.technique as assay, b.tissue as biosample, 
    m.accession as derived_from, m.sex as mice_gender, 
    f.pilot as data_phase,  
    f.submission_id as submission, f.file_uuid as uuid
`;

function formatResults(res) {
        const entry = res.data.results;
        let result = [];
        if (entry.length > 0) {
            const { columns, data } = entry[0];
            
            if (data.length > 0) {
                result = data.map(d => {
                    let tmp = {};
                    d.row.forEach((elem, i) => {
                        tmp[columns[i]] = elem;
                    });
                    return tmp;
                })
            } 
        }

    return result;
}


// WEBPACK FOOTER //
// ./src/components/Neo4jDirect.js